import { render, staticRenderFns } from "./SocialProfileIcon.vue?vue&type=template&id=0cbd5142&scoped=true&"
import script from "./SocialProfileIcon.vue?vue&type=script&lang=ts&"
export * from "./SocialProfileIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SocialProfileIcon.vue?vue&type=style&index=0&id=0cbd5142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd5142",
  null
  
)

export default component.exports